import Logger from '@utils/log'
import * as store from '@store'
import ParseAPI, { publicApi } from '@api/ParseAPI'
import { createQueryString } from '@utils'
import { ablySingleton, saveMergedUserLocal } from '@store'

const log = new Logger('actions/user')

const storeKey = 'user'

export const fetchProfile = async (fields = []) => {
    
    // Return existing data here so we don't break `useQuery`
    // in places like `AppWithUser` (mostly affects dashboard)
    if (store.isFetchingUser.getValue())
        return store.user.getValue()
    
    store.isFetchingUser.setValue(true)
    
    let result = null
    
    try {
        
        const query = fields.length ? createQueryString({ fields }) : ''
        const headers = {}
        
        // If we don't have a local Ably token, ask the server for a new one
        if (!ablySingleton?.token?.length)
            headers['X-Parse-Needs-Ably-Token'] = true
        
        const res = await ParseAPI.get(`users/profile${query}`, {
            headers,
        })
        
        saveMergedUserLocal(res.data)
        
        localStorage.setItem('userId', res.data.id)
        localStorage.setItem('userEmail', res.data.email)
        
        result = res.data
        
    } catch (e) {
        
        log.e('fetchProfile', e)
        
    }
    
    store.isFetchingUser.setValue(false)
    
    return result
    
}

export const fetchUser = async email => {
    
    if (store.isFetchingUser.getValue()) return
    
    store.isFetchingUser.setValue(true)
    
    try {
        
        const res = await publicApi.get(`users/${email}`)
        
        saveMergedUserLocal(res.data, true)
        
    } catch (error) {
        
        log.e(error)
        
    }
    
    store.isFetchingUser.setValue(false)
    
}

export const fetchUsers = async () => {
    
    try {
        
        const res = await ParseAPI.get('users')
        
        store.users.setValue(res.data)
        
    } catch (error) {
        
        log.e(error)
        
    }
    
}

export const updateUser = async (email, user, roleId, subscriptionId) => {
    
    try {
        
        const res = await ParseAPI.post('users', {
            email: email,
            user: user,
            roleId,
            subscriptionId,
        })
        
        store.arrayUpdateById(storeKey, res.data)
        
    } catch (error) {
        
        log.e(error)
        
    }
    
}

export const removeUser = async id => {
    
    try {
        
        const res = await ParseAPI.delete(`users/${id}`)
        
        log.w('@todo removeUser', res.data)
        
    } catch (error) {
        
        log.e(error)
        
    }
    
}

export const updateLocalCredits = async () => {
    
    try {
        
        const res = await ParseAPI.get('users/credits')
        
        store.credits.setValue(res.data)
        
        return res.data
        
    } catch (error) {
        
        log.e(error)
        
    }
    
}

export const resetUserPassword = async (id, currentPassword, newPassword, comfirmNewPassword) => {
    try {
        
        const res = await ParseAPI.post(`users/resetpassword/${id}`, {
            currentPassword,
            newPassword,
            comfirmNewPassword,
        })
        
        return res
        
    } catch (error) {
        
        log.e(error)
        
    }
}

export const setOrganizationStarred = async (id, isStarred) => {
    
    
    const prevUser = store.user.getValue()
    const prevOrg = prevUser.organizations.find(it => it.id === id)
    
    if (!prevOrg)
        return console.warn('setOrganizationStarred: could not find organization', id)
    
    const prevStarred = prevOrg.isStarred
    
    store.user.setValue({
        ...prevUser,
        organizations: prevUser.organizations.map(it => {
            
            if (it.id === id)
                return {
                    ...it,
                    UserOrganizationJoin: {
                        ...it.UserOrganizationJoin,
                        isStarred,
                    },
                }
            
            return it
            
        }),
    })
    
    try {
        
        const res = await ParseAPI.post(`users/orgs/starred/${id}`, {
            isStarred,
        })
        
        return res.data
        
    } catch (e) {
        
        log.e(e)
        
        // Unset the optimistic update
        store.user.setValue({
            ...prevUser,
            organizations: prevUser.organizations.map(it => {
                
                if (it.id === id)
                    return {
                        ...it,
                        UserOrganizationJoin: {
                            ...it.UserOrganizationJoin,
                            isStarred: prevStarred,
                        },
                    }
                
                return it
                
            }),
        })
        
        throw e
        
    }
    
}
